

















import Context from "@/mixins/context";
import { Component, Mixins, Prop } from "vue-property-decorator";
@Component
export default class Error429Modal extends Mixins(Context) {
  @Prop({ default: null })
  public retryAfter!: number;
  // Data
  public interval: ReturnType<typeof setTimeout> | null = null;
  public countdown: number | null = null;
  // Computed
  public get passwordResetRoute() {
    if (this.isAdmin) return { name: "adminForgottenPassword" };
    return { name: "forgottenPassword" };
  }
  public get i18nCountdown() {
    if (!this.countdown)
      return (this.$t(
        this.countdown === 0 ? "_.now" : "_.shortly"
      ) as string).toLowerCase();
    const duration = this.$moment.duration(this.countdown, "seconds");
    return (this.$t("_.in_time", {
      time: this.$_.compact([
        duration.minutes() && this.$tc("_plurals.minute", duration.minutes()),
        duration.seconds() && this.$tc("_plurals.second", duration.seconds())
      ]).join(" ")
    }) as string).toLowerCase();
  }
  // Life-cycle methods
  public created() {
    if (!this.retryAfter || this.interval) return;
    this.$set(this, "countdown", this.retryAfter);
    this.interval = setInterval(() => {
      --(this.countdown as number);
      if (!this.countdown && this.interval) clearInterval(this.interval);
    }, 1000);
  }

  public beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
}
